import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

import { ApplicationRoute } from '../../constants';

function setupComposedChart(): void {
  applicationModuleRegistry.register({
    entry: 'composed-chart',
    id: 'composed-chart',
    name: 'modules.composed-chart',
    route: ApplicationRoute.COMPOSED_CHART,
  });
}

export {
  setupComposedChart,
};
